/**
 * Google Click ID → атрибуты корзины (для серверной загрузки конверсий с прибылью).
 *
 * Зачем: Shopify вычищает query-строку из landing page заказа, поэтому gclid
 * из рекламной ссылки на сервере не виден. Этот скрипт запоминает его сам.
 *
 * Как: при заходе с ?gclid= / ?gbraid= / ?wbraid= кладём id в first-party куку
 * на 90 дней (столько Google хранит клик). Когда в корзине что-то есть — пишем
 * атрибуты _gclid / _gbraid / _wbraid / _gcl_ts / _consent через /cart/update.js;
 * они приезжают в заказ как note_attributes. Префикс «_» прячет их от покупателя.
 *
 * Правило «последний клик»: новый id из URL полностью заменяет старую запись —
 * так же ведёт себя штатная кука Google _gcl_aw. gclid и gbraid могут прийти
 * вместе (это одна пара), gbraid и wbraid вместе не бывает.
 *
 * Никакой себестоимости и никаких сумм здесь нет — только идентификатор клика.
 */
(function () {
  'use strict';
  var COOKIE = '_mk_gcl';
  var DAYS = 90;
  var ID_RE = /^[A-Za-z0-9_-]{8,200}$/;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, timer = null;

  function readCookie() {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      return m ? JSON.parse(decodeURIComponent(m[1])) : null;
    } catch (e) { return null; }
  }
  function writeCookie(rec) {
    try {
      document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(rec)) +
        '; max-age=' + (DAYS * 86400) + '; path=/; SameSite=Lax; Secure';
    } catch (e) {}
  }
  function fromUrl() {
    var q; try { q = new URLSearchParams(location.search); } catch (e) { return null; }
    var g = q.get('gclid') || '', gb = q.get('gbraid') || '', wb = q.get('wbraid') || '';
    if (!ID_RE.test(g)) g = '';
    if (!ID_RE.test(gb)) gb = '';
    if (!ID_RE.test(wb)) wb = '';
    if (!g && !gb && !wb) return null;
    // gbraid и wbraid одновременно Google не принимает — оставляем gbraid
    if (gb && wb) wb = '';
    return { g: g, gb: gb, wb: wb, ts: new Date().toISOString() };
  }

  // Согласие на рекламные данные — из Shopify Customer Privacy API (баннер cookies).
  // 'unknown', если API нет или баннер ещё не показан.
  function consent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return 'unknown';
      if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return 'unknown';
      return cp.marketingAllowed() ? 'granted' : 'denied';
    } catch (e) { return 'unknown'; }
  }

  var incoming = fromUrl();
  if (incoming) writeCookie(incoming);

  function wanted() {
    var rec = readCookie();
    if (!rec || (!rec.g && !rec.gb && !rec.wb)) return null;
    return { _gclid: rec.g || '', _gbraid: rec.gb || '', _wbraid: rec.wb || '', _gcl_ts: rec.ts || '', _consent: consent() };
  }

  // Пишем атрибуты только если корзина не пуста (не плодим пустые корзины)
  // и только если они отличаются от того, что уже в корзине.
  function sync() {
    if (busy) return;
    var want = wanted();
    if (!want) return;
    busy = true;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        var have = cart.attributes || {}, diff = false;
        for (var k in want) if ((have[k] || '') !== want[k]) { diff = true; break; }
        if (!diff) return;
        return fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: want })
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 600); }

  // Триггеры: загрузка страницы, изменения корзины (события темы + перехват fetch),
  // возврат из bfcache, ответ покупателя на баннер cookies.
  if (window.eventBus && typeof window.eventBus.on === 'function') {
    ['cart:added', 'update:cart:drawer', 'qty:change'].forEach(function (e) { window.eventBus.on(e, schedule); });
  }
  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function () {
      var url = arguments[0]; if (url && typeof url === 'object' && url.url) url = url.url;
      var res = orig.apply(this, arguments);
      if (!busy && typeof url === 'string' && /\/cart\/(add|change|clear)/.test(url)) res.then(schedule).catch(function () {});
      return res;
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  document.addEventListener('visitorConsentCollected', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
